'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import Application from 'pricing-pages-unified-ui/containers/Application';
import { Route, Switch, Redirect } from 'react-router-dom';
import ErrorPage from './components/ErrorPage';
import CodeSplitEnvWrapper from 'pricing-pages-unified-ui/components/CodeSplitEnvWrapper';
import Loadable from 'UIComponents/decorators/Loadable';
import { useSelector } from 'react-redux';
import { isMon569VariantSelector, mon569VariantSelector } from './selectors/ExperimentTreatmentSelectors';
import { TAB_IDS } from './constants/Mon569SidenavConfig';
import ProductPage from './components/MON569/ProductPage';
import { CMS, MARKETING, OPERATIONS, SERVICE, SALES } from 'self-service-api/constants/ProductLines';
import FreeToolsPage from './components/free-tools-page/FreeToolsPage';
import BundlePage from './components/BundlePage';
import SalesHubPage from './components/SalesHubPage';
import ServiceHubPage from './components/ServiceHubPage';
import CmsHubPage from './components/cms-hub-page/CmsHubPage';
import MarketingHubPage from './components/MarketingHubPage';
import CrmSuitePage from './components/suite-page/CrmSuitePage';
import OperationsHubPage from './components/product-pages/OperationsHubPage';
import Mon569SuitePage from './components/MON569/Mon569SuitePage';
import Mon569BundlePage from './components/MON569/Mon569BundlePage';
import Mon569FreeToolsPage from './components/MON569/Mon569FreeToolsPage';
import { createToObject } from 'pricing-pages-lib/utils/queryParamUtils';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import { isUngatedForSeatsSelector } from './selectors/GatingSelectors';
import { productsAndAddons } from 'self-service-api/core/utilities/links';
import { isAppAuthSelector } from './selectors/ConfigSelectors';
const ConstantsTest = Loadable({
  loader: () => import(
  /* webpackChunkName: "test-chunk" */
  'pricing-pages-unified-ui/components/ConstantsTest'),
  LoadingComponent: () => null
});
const ContactsConfirmationPage = Loadable({
  loader: () => import(
  /* webpackChunkName: "contacts-confirmation" */
  'pricing-pages-unified-ui/components/contacts-confirmation-page/ContactsConfirmationPage'),
  LoadingComponent: () => null
});

const ProductPageRoute = ({
  path,
  Component = ProductPage,
  productLine
}) => {
  const mon569Variant = useSelector(mon569VariantSelector);
  return /*#__PURE__*/_jsx(Route, {
    path: `${path}/:tab?`,
    render: ({
      match: {
        params: {
          tab
        }
      }
    }) => {
      if (!tab || !Object.keys(TAB_IDS).includes(tab)) {
        getUsageTracker().setProperties({
          defaultedTab: mon569Variant
        });
        return /*#__PURE__*/_jsx(Redirect, {
          to: createToObject(`${path}/${mon569Variant}`)
        });
      }

      return /*#__PURE__*/_jsx(Component, {
        productLine: productLine
      });
    }
  });
};

function Mon569Routes() {
  return /*#__PURE__*/_jsx(Application, {
    children: /*#__PURE__*/_jsxs(Switch, {
      children: [/*#__PURE__*/_jsx(Route, {
        path: "/crm",
        component: Mon569FreeToolsPage
      }), /*#__PURE__*/_jsx(Route, {
        path: "/bundle",
        component: Mon569BundlePage
      }), /*#__PURE__*/_jsx(Route, {
        path: "/confirm-contacts",
        render: ({
          location: {
            state
          },
          history
        }) => {
          if (!state) {
            return history.goBack();
          }

          return /*#__PURE__*/_jsx(ContactsConfirmationPage, {});
        }
      }), /*#__PURE__*/_jsx(Route, {
        path: "/legacy-starter-confirmation",
        children: /*#__PURE__*/_jsx(CodeSplitEnvWrapper, {
          authedComponentLoader: () => import(
          /* webpackChunkName: "legacy-starter-sidegrade" */
          `pricing-pages-unified-ui/components/legacy-starter-sidegrade-page/SidegradeWarningPage`),
          publicComponentLoader: () => import(
          /* webpackChunkName: "error-page" */
          `pricing-pages-unified-ui/components/ErrorPage`)
        })
      }), /*#__PURE__*/_jsx(Route, {
        path: "/contact-sales",
        children: /*#__PURE__*/_jsx(CodeSplitEnvWrapper, {
          authedComponentLoader: () => import(
          /* webpackChunkName: "error-page" */
          `pricing-pages-unified-ui/components/ErrorPage`),
          publicComponentLoader: () => import(
          /* webpackChunkName: "contact-sales-page" */
          'pricing-pages-unified-ui/components/contact-sales-page/ContactSalesPage'),
          authedComponentProps: {},
          publicComponentProps: {}
        })
      }), /*#__PURE__*/_jsx(ProductPageRoute, {
        path: "/sales",
        productLine: SALES
      }), /*#__PURE__*/_jsx(ProductPageRoute, {
        path: "/service",
        productLine: SERVICE
      }), /*#__PURE__*/_jsx(ProductPageRoute, {
        path: "/cms",
        productLine: CMS
      }), /*#__PURE__*/_jsx(ProductPageRoute, {
        path: "/marketing",
        productLine: MARKETING
      }), /*#__PURE__*/_jsx(ProductPageRoute, {
        path: "/operations",
        productLine: OPERATIONS
      }), /*#__PURE__*/_jsx(ProductPageRoute, {
        path: "/suite",
        Component: Mon569SuitePage
      }), /*#__PURE__*/_jsx(Redirect, {
        from: "/growth-suite",
        to: createToObject('/suite')
      }), /*#__PURE__*/_jsx(Redirect, {
        from: "/",
        exact: true,
        to: createToObject('/marketing')
      }), /*#__PURE__*/_jsx(Route, {
        path: "/_constants-test",
        children: /*#__PURE__*/_jsx(ConstantsTest, {})
      }), /*#__PURE__*/_jsx(Route, {
        component: ErrorPage
      })]
    })
  });
}

function Routes({
  defaultRoute
}) {
  const isMon569Variant = useSelector(isMon569VariantSelector);
  const isUngatedForSeats = useSelector(isUngatedForSeatsSelector);
  const isAppAuth = useSelector(isAppAuthSelector); // Temporary while waiting for redesign productization
  // Only redirecting in-app to confirm proxy behavior in QA now that the public flag is true

  if (isUngatedForSeats && isAppAuth) {
    window.location.href = productsAndAddons(true);
    return null;
  }

  if (isMon569Variant) return /*#__PURE__*/_jsx(Mon569Routes, {});
  return /*#__PURE__*/_jsx(Application, {
    children: /*#__PURE__*/_jsxs(Switch, {
      children: [/*#__PURE__*/_jsx(Route, {
        path: "/:page/*",
        render: ({
          location,
          match: {
            params: {
              page
            }
          }
        }) => /*#__PURE__*/_jsx(Redirect, {
          to: Object.assign({}, location, {
            pathname: `/${page}`
          })
        })
      }), /*#__PURE__*/_jsx(Route, {
        path: "/confirm-contacts",
        render: ({
          location: {
            state
          },
          history
        }) => {
          if (!state) {
            return history.goBack();
          }

          return /*#__PURE__*/_jsx(ContactsConfirmationPage, {});
        }
      }), /*#__PURE__*/_jsx(Route, {
        path: "/legacy-starter-confirmation",
        children: /*#__PURE__*/_jsx(CodeSplitEnvWrapper, {
          authedComponentLoader: () => import(
          /* webpackChunkName: "legacy-starter-sidegrade" */
          `pricing-pages-unified-ui/components/legacy-starter-sidegrade-page/SidegradeWarningPage`),
          publicComponentLoader: () => import(
          /* webpackChunkName: "error-page" */
          `pricing-pages-unified-ui/components/ErrorPage`)
        })
      }), /*#__PURE__*/_jsx(Route, {
        path: "/contact-sales",
        children: /*#__PURE__*/_jsx(CodeSplitEnvWrapper, {
          authedComponentLoader: () => import(
          /* webpackChunkName: "error-page" */
          `pricing-pages-unified-ui/components/ErrorPage`),
          publicComponentLoader: () => import(
          /* webpackChunkName: "contact-sales-page" */
          'pricing-pages-unified-ui/components/contact-sales-page/ContactSalesPage'),
          authedComponentProps: {},
          publicComponentProps: {}
        })
      }), /*#__PURE__*/_jsx(Route, {
        path: "/crm",
        component: FreeToolsPage
      }), /*#__PURE__*/_jsx(Route, {
        path: "/bundle",
        component: BundlePage
      }), /*#__PURE__*/_jsx(Route, {
        path: "/sales",
        component: SalesHubPage
      }), /*#__PURE__*/_jsx(Route, {
        path: "/service",
        component: ServiceHubPage
      }), /*#__PURE__*/_jsx(Route, {
        path: "/cms",
        component: CmsHubPage
      }), /*#__PURE__*/_jsx(Route, {
        path: "/marketing",
        component: MarketingHubPage
      }), /*#__PURE__*/_jsx(Redirect, {
        from: "/growth-suite",
        to: "/suite"
      }), /*#__PURE__*/_jsx(Route, {
        path: "/suite",
        component: CrmSuitePage
      }), /*#__PURE__*/_jsx(Route, {
        path: "/operations",
        component: OperationsHubPage
      }), /*#__PURE__*/_jsx(Redirect, {
        from: "/",
        exact: true,
        to: defaultRoute
      }), /*#__PURE__*/_jsx(Route, {
        path: "/_constants-test",
        children: /*#__PURE__*/_jsx(ConstantsTest, {})
      }), /*#__PURE__*/_jsx(Route, {
        component: ErrorPage
      })]
    })
  });
}

export default Routes;